// extracted by mini-css-extract-plugin
export default {"root":"_ZsdN","header":"rbrp3","closeButton":"dh1VS","currencyList":"StRrG","currencyItem":"DXUiO","checkIcon":"bvVdF","shader":"gLVlx","tablet":"AOXhZ"};